<template>
    <!--暗巷首页-->
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>

    <div class="container errong phome-container-box">
        <div class="col-12">
            <ZhaiThreeTuttonsPC></ZhaiThreeTuttonsPC>
        </div>
        <div class="col-12">
            <ZhaiTwoTuttonsPC></ZhaiTwoTuttonsPC>
        </div>

        <!-- 包含了三个按钮组件 -->

        <div class="row mt-2">
            <div class="col-12 bg-white text-black p-3 tn mb-2 brl d-flex align-items-start justify-content-between">
                <div class="province-label mr-2 daxiao jiacu">省份:</div>
                <!-- 省份标签 -->

                <div class="province-links d-flex flex-wrap daxiao">
                    <a
                            v-for="province in provinces"
                            :key="province.name"
                            class="text-decoration-none mx-2 text-black"
                            :class="{ active: selectedProvince.name === province.name }"
                            @click.prevent="selectProvince(province)"
                            href="#"
                    >
                        <span>{{ province.name }}</span>
                    </a>
                    <!-- 动态生成的省份链接，选中的省份会添加active类 -->
                </div>
            </div>
        </div>

        <div v-if="showCities" class="row mt-2">
            <div class="col-12 bg-white text-black p-3 tn mb-2 brl d-flex align-items-start justify-content-between">
                <div class="province-label mr-2 daxiao jiacu">地市:</div>
                <!-- 地市标签 -->

                <div class="province-links d-flex flex-wrap daxiao">
                    <router-link
                            v-for="city in selectedProvince.cities"
                            :key="city"
                            class="text-decoration-none mx-2 text-black"
                            :class="{ active: selectedCity === city }"
                            @click.prevent="selectCity(city)"
                            to="#"
                    >
                        <span>{{ city }}</span>
                    </router-link>
                    <!-- 动态生成的地市链接，选中的地市会添加active类 -->
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 bg-white text-black p-3 tn float-left mb-3 brl d-flex align-items-start justify-content-between">
                <div class="province-label mr-2 daxiao jiacu">排序:</div>
                <!-- 排序标签 -->

                <div class="province-links d-flex flex-wrap daxiao">
                    <a
                            class="text-decoration-none mx-2 text-black"
                            :class="{ active: sortBy === 'publishTime' }"
                            href="#"
                            @click.prevent="changeSort('publishTime')"
                    >
                        <span>发布时间</span>
                    </a>
                    <a
                            class="text-decoration-none mx-2 text-black"
                            :class="{ active: sortBy === 'collection' }"
                            href="#"
                            @click.prevent="changeSort('collection')"
                    >
                        <span>收藏数量</span>
                    </a>
                    <!-- 两个排序链接，选中的排序方式会添加active类 -->
                </div>
            </div>
        </div>
    </div>

    <!-- 这个隐藏挂载点只负责让子组件请求数据，不占页面空间 -->
    <div class="banner-probe">
        <VipUpgradeDiffBanner
                ref="vipDiffBanner"
                :user-id="getUser && getUser.id"
                :text-prefix="homeUpgradePrefix"
                @select="handleSelectPermanentUpgrade"
        />
    </div>

    <!-- 只有真正满足补差价条件时，才显示页面里的红条 -->
    <div
            v-if="showUpgradeBanner"
            class="container errong2  phome-container-box"
    >
        <div class="home-diff-banner-wrap" @click="triggerBannerClick">
            <div class="home-diff-banner-text">
                {{ fullBannerText }}
            </div>
        </div>
    </div>

    <div class="container errong2 phome-container-box">
        <div class="row card-container">
            <div class="col-md-4 mb-1" v-for="item in items" :key="item.id">
                <ZhaiCardPC :data="item"></ZhaiCardPC>
                <!-- 动态生成的卡片组件 -->
            </div>
        </div>
        <div class="bg-white my-2 p-3 G-Field" style="text-align:center;">
            <nav aria-label="Page navigation example">
                <ul class="pagination">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" aria-label="Previous" @click.prevent="fetchPage(currentPage - 1)">
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    <li
                            class="page-item"
                            v-for="page in paginationPages"
                            :key="page"
                            :class="{ active: currentPage === page }"
                    >
                        <a
                                v-if="page !== '...'"
                                class="page-link"
                                href="#"
                                @click.prevent="fetchPage(page)"
                        >
                            {{ page }}
                        </a>
                        <span v-else class="page-link">...</span>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" href="#" aria-label="Next" @click.prevent="fetchPage(currentPage + 1)">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                    <!-- 分页导航 -->
                </ul>
            </nav>
        </div>
    </div>

    <div class="gongxi2"></div>
    <!-- 一个空的div，用于调整页面布局 -->

    <!-- 升级支付 模态框 -->
    <div class="modal fade" id="upgradeModal" tabindex="-1" aria-labelledby="upgradeModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="upgradeModalLabel">升级支付</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div id="step1">
                        <div>
                            升级VIP目前仅支持支付宝，请确认升级的VIP类型及支付金额是否正确，点击“支付”进行支付。
                        </div>
                        <div class="mt-2">
                            <strong>升级类型：</strong>
                            <span id="uplevel">{{ modalData.type }}</span>
                        </div>
                        <div class="mt-2">
                            <strong>支付金额：</strong>
                            <span id="payamount">{{ modalData.amount }}元</span>
                        </div>
                        <div class="mt-2">
                            <strong>支付方式：</strong>
                            <label class="pay-option1">
                                <input type="radio" name="paytype" value="2040" v-model="payType" id="alipay">
                                {{ alipayOptionText }}
                            </label>
                        </div>

                        <div class="mt-2" style="color:red;">
                            如果支付加载不出来，多试几次就成功了。
                        </div>

                      <div class="text-center mt-5 d-flex justify-content-center gap-4">
                        <button id="startPayBtn" class="btn btn-success" @click="startPayment">支付</button>
                        <button class="btn btn-success" data-bs-dismiss="modal">关闭</button>
                      </div>

                    </div>

                  <div id="step2" style="display:none;">
                    <div id="paymsg" style="text-align: center;font-size: 1rem;font-weight: bold;"></div>
                    <p id="code_msg" style="text-align: center;background: #040404;color: #ffeb00;font-size: 1rem;">
                      如页面出现支付步骤文字说明，请务必看完（尤其是付款注意事项）再进行支付。
                    </p>
                    <p style="text-align: center;font-size: 1rem;color: #000;">
                      请确认支付完成后，再点击“支付完成”
                    </p>
                    <div class="text-center d-flex justify-content-center gap-4">
                      <button id="btnpaysucess" class="btn btn-primary" @click="onManualCheckPayment">支付完成</button>
                      <button class="btn btn-primary" data-bs-dismiss="modal">关闭</button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ZhaiFootPC></ZhaiFootPC>
    <!-- 包含了底部组件 -->
</template>

<script>
    import http from "../utils/http.js";
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import ZhaiCardPC from "../componentspc/ZhaiBACardPC";
    import ZhaiTwoTuttonsPC from "../componentspc/ZhaiTwoTuttonsPC";
    import ZhaiThreeTuttonsPC from "../componentspc/ZhaiThreeTuttonsPC";
    import VipUpgradeDiffBanner from "../components/VipUpgradeDiffBanner.vue";
    import { mapGetters } from "vuex";
    import { Modal } from "bootstrap";
    import QRCode from "qrcodejs2";

    export default {
        name: "PBackAlley",
        components: {
            ZhaiHeadPC,
            ZhaiFootPC,
            ZhaiCardPC,
            ZhaiThreeTuttonsPC,
            ZhaiTwoTuttonsPC,
            VipUpgradeDiffBanner
        },
        data() {
            return {
                items: [],
                currentPage: 1,
                totalPages: 1,
                sortBy: "publishTime",
                selectedProvince: { name: "全部", cities: [] },
                selectedCity: "全部",
                selectedFeature: "不限",
                provinces: this.getProvinces(),
                showCities: false,
                provinceKeyword: "",
                cityKeyword: "",
                sortKeyword: "发布时间",

                modalData: { type: "", amount: 0 },
                payType: "2040",
                orderId: null,
                manualPolling: false,

                showUpgradeBanner: false,
                bannerSyncTimer: null
            };
        },
        computed: {
            ...mapGetters(["getUser"]),

            paginationPages() {
                let pages = [];
                let startPage = Math.max(1, this.currentPage - 2);
                let endPage = Math.min(this.totalPages, this.currentPage + 2);

                for (let i = startPage; i <= endPage; i++) {
                    pages.push(i);
                }

                if (startPage > 1) {
                    pages.unshift("...");
                    pages.unshift(1);
                }

                if (endPage < this.totalPages) {
                    pages.push("...");
                    pages.push(this.totalPages);
                }

                return pages;
            },

            homeUpgradePrefix() {
                const username = this.getUser?.username || "会员";
                return `尊敬的会员 ${username}：限时补差价 `;
            },

            alipayOptionText() {
                return "支付宝";
            },

            fullBannerText() {
                const banner = this.$refs.vipDiffBanner;
                if (!banner || !banner.upgradeInfo) return "";

                const username = this.getUser?.username || "会员";
                const price = banner.displayPrice(banner.upgradeInfo.upgradePrice);
                const countdown = banner.countdownText || "";

                return `尊敬的会员 ${username}：限时补差价 ${price}元，即可升级为永久会员！${countdown ? `（剩余${countdown}）` : ""}`;
            }
        },
        mounted() {
            this.fetchPage(1);
            this.startBannerSync();
        },
        beforeUnmount() {
            this.stopBannerSync();
        },
        methods: {
            startBannerSync() {
                this.stopBannerSync();

                this.bannerSyncTimer = setInterval(() => {
                    const banner = this.$refs.vipDiffBanner;
                    if (!banner) {
                        this.showUpgradeBanner = false;
                        return;
                    }

                    this.showUpgradeBanner = !!banner.visible;
                }, 500);
            },

            stopBannerSync() {
                if (this.bannerSyncTimer) {
                    clearInterval(this.bannerSyncTimer);
                    this.bannerSyncTimer = null;
                }
            },

            triggerBannerClick() {
                const banner = this.$refs.vipDiffBanner;
                if (banner && typeof banner.handleClick === "function") {
                    banner.handleClick();
                }
            },

            // 更新页面标题
            updateTitle() {
                const titleParts = [
                    this.provinceKeyword,
                    this.cityKeyword,
                    this.featureKeyword
                ].filter(Boolean);

                document.title = titleParts.length ? `${titleParts.join(" ")}的全部暗巷信息 - 御凤楼.it.com` : "御凤楼.it.com";
            },

            changeSort(sortOption) {
                this.sortBy = sortOption;
                this.sortKeyword = sortOption === "publishTime" ? "发布时间" : "收藏数量";
                this.updateTitle();
                this.fetchPage(1);
            },

            fetchPage(page) {
                if (page === "..." || page < 1 || page > this.totalPages) {
                    return;
                }

                const params = new URLSearchParams({
                    pageNum: page || 1,
                    pageSize: 24,
                    sortBy: this.sortBy
                });

                if (this.selectedProvince.name !== "全部") {
                    params.append("province", this.selectedProvince.name);
                }
                if (this.selectedCity !== "" && this.selectedCity !== "全部") {
                    params.append("city", this.selectedCity);
                }
                if (this.selectedFeature !== "不限") {
                    params.append("high", this.selectedFeature);
                }

                const url = `/platform/frontEnd/backalleyList?${params.toString()}`;

                http.get(url).then(response => {
                    if (response.data.status === 1) {
                        this.items = response.data.data.list || [];
                        this.currentPage = response.data.data.pageNum || 1;
                        this.totalPages = response.data.data.pages || 1;
                    } else {
                        alert(response.data.msg);
                    }
                }).catch(error => {
                    console.error("请求失败:", error);
                    alert("请求失败，请稍后重试。");
                });
            },

            selectProvince(province) {
                this.selectedProvince = province;
                this.provinceKeyword = province.name !== "全部" ? province.name : "";
                this.selectedCity = "全部";
                this.cityKeyword = "";
                this.showCities = province.name !== "全部";
                this.updateTitle();
                this.fetchPage(1);
            },

            selectCity(city) {
                this.selectedCity = city;
                this.cityKeyword = city !== "全部" ? city : "";
                this.updateTitle();
                this.fetchPage(1);
            },

            selectFeature(feature) {
                this.selectedFeature = feature;
                this.featureKeyword = feature !== "不限" ? feature : "";
                this.updateTitle();
                this.fetchPage(1);
            },

            handleSelectPermanentUpgrade(payload) {
                this.modalData.type = payload.type;
                this.modalData.amount = payload.amount;
                this.openModal();
            },

            openModal() {
                document.getElementById("step1").style.display = "block";
                document.getElementById("step2").style.display = "none";

                const paymsg = document.getElementById("paymsg");
                if (paymsg) {
                    paymsg.innerHTML = "";
                }

                const modalElement = document.getElementById("upgradeModal");
                const modalInstance = new Modal(modalElement);
                modalInstance.show();
            },

            resetPayButton() {
                const payButton = document.getElementById("startPayBtn");
                if (payButton) {
                    payButton.textContent = "支付";
                    payButton.disabled = false;
                }
            },

            startPayment() {
                const payButton = document.getElementById("startPayBtn");
                if (payButton) {
                    payButton.textContent = "生成中";
                    payButton.disabled = true;
                }

                const { id: userid, username, email } = this.getUser || {};
                if (!userid || !username || !email) {
                    this.resetPayButton();
                    alert("用户信息不完整，请重新登录！");
                    return;
                }

                let requestUrl = "";

                if (this.modalData.type === "限时补差价升级永久会员") {
                    requestUrl = `/platform/frontEndPayment/requestPermanentUpgrade?userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
                } else {
                    requestUrl = `/platform/frontEndPayment/request?name=${encodeURIComponent(this.modalData.type)}&money=${this.modalData.amount}&userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
                }

                http.get(requestUrl)
                    .then(response => {
                        const res = response.data;

                        if (res && res.status === 1 && res.data) {
                            const { payUrl, mchOrderNo } = res.data;

                            if (!payUrl) {
                                this.resetPayButton();
                                alert("支付链接为空，请联系管理员！");
                                return;
                            }

                            this.orderId = mchOrderNo;
                            this.generateQRCode(payUrl);
                        } else {
                            this.resetPayButton();
                            const errorMessage = res?.msg || "未知错误";
                            alert(`支付请求失败：${errorMessage}`);
                        }
                    })
                    .catch(error => {
                        this.resetPayButton();
                        alert(`请求支付失败，请重试。错误详情: ${error.message}`);
                    });
            },

            generateQRCode(payUrl) {
                document.getElementById("paymsg").innerHTML = "请用手机相机扫描下方二维码，从浏览器打开，将自动跳转支付。";

                const qrCodeContainer = document.createElement("div");
                qrCodeContainer.id = "qrcode";
                qrCodeContainer.style.width = "200px";
                qrCodeContainer.style.height = "200px";
                qrCodeContainer.style.marginTop = "20px";

                document.getElementById("paymsg").appendChild(qrCodeContainer);

                new QRCode(qrCodeContainer, {
                    text: payUrl,
                    width: 200,
                    height: 200,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                  // ✅ 统一改 L（稳定）
                  correctLevel: QRCode.CorrectLevel.L
                });

                document.getElementById("step1").style.display = "none";
                document.getElementById("step2").style.display = "block";

                let remainingTime = 300;

                const countdown = document.createElement("p");
                countdown.id = "countdown";
                countdown.style.textAlign = "center";
                countdown.style.marginTop = "10px";
                countdown.style.fontWeight = "normal";
                countdown.style.color = "rgba(255, 127, 127)";
                countdown.style.fontSize = "0.9rem";
                document.getElementById("paymsg").appendChild(countdown);

                const timer = setInterval(() => {
                    if (remainingTime <= 0) {
                        clearInterval(timer);
                        countdown.innerHTML = "支付已超时，请关闭重新选择支付！";
                        qrCodeContainer.style.filter = "blur(5px)";
                        this.resetPayButton();
                    } else {
                        const minutes = Math.floor(remainingTime / 60);
                        const seconds = remainingTime % 60;
                        countdown.innerHTML = `请在 ${minutes}:${seconds < 10 ? "0" + seconds : seconds} 内完成支付`;
                        remainingTime--;
                    }
                }, 1000);
            },

            onManualCheckPayment() {
                this.manualPolling = true;
                this.checkPaymentStatus();
            },

            checkPaymentStatus() {
                if (!this.orderId) return;

                const statusUrl = `/platform/frontEndPayment/checkPaymentStatus?outTradeNo=${this.orderId}`;
                fetch(statusUrl)
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === 1) {
                            this.handlePaymentSuccessStatus();
                        } else if (this.manualPolling) {
                            alert("未检测到支付完成，请稍后重试");
                        }
                    })
                    .catch(error => {
                        console.error("轮询支付状态异常:", error);
                    });
            },

            handlePaymentSuccessStatus() {
                this.$store.dispatch("checkLoginStatus");

                const banner = this.$refs.vipDiffBanner;
                if (banner && typeof banner.refresh === "function") {
                    banner.refresh();
                }

                this.fetchPage(this.currentPage || 1);
                alert("支付已成功");
            },

            getProvinces() {
                return [
                    { name: "全部", cities: [] },
                    { name: "北京", cities: ["全部", "海淀", "丰台", "门头沟", "昌平", "房山", "大兴", "朝阳", "东城", "石景山", "西城", "通州", "顺义", "怀柔", "平谷", "密云", "延庆"] },
                    { name: "上海", cities: ["全部", "黄浦", "徐汇", "长宁", "静安", "普陀", "虹口", "杨浦", "闵行", "宝山", "嘉定", "浦东", "金山", "松江", "青浦", "奉贤", "崇明"] },
                    { name: "天津", cities: ["全部", "和平", "河东", "河西", "南开", "河北", "红桥", "东丽", "西青", "津南", "北辰", "武清", "宝坻", "滨海", "宁河", "静海", "蓟州"] },
                    { name: "重庆", cities: ["全部", "万州", "涪陵", "渝中", "大渡口", "江北", "沙坪坝", "九龙坡", "南岸", "北碚", "綦江", "大足", "渝北", "巴南", "黔江", "长寿", "江津", "合川", "永川", "南川", "璧山", "铜梁", "潼南", "荣昌", "开州", "梁平", "武隆"] },
                    { name: "河北", cities: ["全部", "石家庄", "唐山", "秦皇岛", "邯郸", "邢台", "保定", "张家口", "承德", "沧州", "廊坊", "衡水"] },
                    { name: "山西", cities: ["全部", "太原", "大同", "阳泉", "长治", "晋城", "朔州", "晋中", "运城", "忻州", "临汾", "吕梁"] },
                    { name: "辽宁", cities: ["全部", "沈阳", "大连", "鞍山", "抚顺", "本溪", "丹东", "锦州", "营口", "阜新", "辽阳", "盘锦", "铁岭", "朝阳", "葫芦岛"] },
                    { name: "吉林", cities: ["全部", "长春", "吉林", "四平", "辽源", "通化", "白山", "松原", "白城", "延边"] },
                    { name: "黑龙江", cities: ["全部", "哈尔滨", "齐齐哈尔", "鸡西", "鹤岗", "双鸭山", "大庆", "伊春", "佳木斯", "七台河", "牡丹江", "黑河", "绥化", "大兴安岭"] },
                    { name: "江苏", cities: ["全部", "南京", "无锡", "徐州", "常州", "苏州", "南通", "连云港", "淮安", "盐城", "扬州", "镇江", "泰州", "宿迁"] },
                    { name: "浙江", cities: ["全部", "杭州", "宁波", "温州", "嘉兴", "湖州", "绍兴", "金华", "衢州", "舟山", "台州", "丽水"] },
                    { name: "安徽", cities: ["全部", "合肥", "芜湖", "蚌埠", "淮南", "马鞍山", "淮北", "铜陵", "安庆", "黄山", "滁州", "阜阳", "宿州", "巢湖", "六安", "亳州", "池州", "宣城"] },
                    { name: "福建", cities: ["全部", "福州", "厦门", "莆田", "三明", "泉州", "漳州", "南平", "龙岩", "宁德"] },
                    { name: "江西", cities: ["全部", "南昌", "景德镇", "萍乡", "九江", "新余", "鹰潭", "赣州", "吉安", "宜春", "抚州", "上饶"] },
                    { name: "山东", cities: ["全部", "济南", "青岛", "淄博", "枣庄", "东营", "烟台", "潍坊", "济宁", "泰安", "威海", "日照", "莱芜", "临沂", "德州", "聊城", "滨州", "菏泽"] },
                    { name: "河南", cities: ["全部", "郑州", "开封", "洛阳", "平顶山", "安阳", "鹤壁", "新乡", "焦作", "濮阳", "许昌", "漯河", "三门峡", "南阳", "商丘", "信阳", "周口", "驻马店", "济源"] },
                    { name: "湖北", cities: ["全部", "武汉", "黄石", "十堰", "宜昌", "襄阳", "鄂州", "荆门", "孝感", "荆州", "黄冈", "咸宁", "随州", "恩施"] },
                    { name: "湖南", cities: ["全部", "长沙", "株洲", "湘潭", "衡阳", "邵阳", "岳阳", "常德", "张家界", "益阳", "郴州", "永州", "怀化", "娄底", "湘西"] },
                    { name: "广东", cities: ["全部", "广州", "韶关", "深圳", "珠海", "汕头", "佛山", "江门", "湛江", "茂名", "肇庆", "惠州", "梅州", "汕尾", "河源", "阳江", "清远", "东莞", "中山", "潮州", "揭阳", "云浮"] },
                    { name: "广西", cities: ["全部", "南宁", "柳州", "桂林", "梧州", "北海", "防城港", "钦州", "贵港", "玉林", "百色", "贺州", "河池", "来宾", "崇左"] },
                    { name: "海南", cities: ["全部", "海口", "三亚", "三沙", "儋州"] },
                    { name: "四川", cities: ["全部", "成都", "自贡", "攀枝花", "泸州", "德阳", "绵阳", "广元", "遂宁", "内江", "乐山", "南充", "眉山", "宜宾", "广安", "达州", "雅安", "巴中", "资阳"] },
                    { name: "贵州", cities: ["全部", "贵阳", "六盘水", "遵义", "安顺", "毕节", "铜仁"] },
                    { name: "云南", cities: ["全部", "昆明", "曲靖", "玉溪", "保山", "昭通", "丽江", "普洱", "临沧"] },
                    { name: "西藏", cities: ["全部", "拉萨"] },
                    { name: "陕西", cities: ["全部", "西安", "铜川", "宝鸡", "咸阳", "渭南", "延安", "汉中", "榆林", "安康", "商洛"] },
                    { name: "甘肃", cities: ["全部", "兰州", "嘉峪关", "金昌", "白银", "天水", "武威", "张掖", "平凉", "酒泉", "庆阳", "定西", "陇南"] },
                    { name: "青海", cities: ["全部", "西宁", "海东"] },
                    { name: "宁夏", cities: ["全部", "银川", "石嘴山", "吴忠", "固原", "中卫"] },
                    { name: "新疆", cities: ["全部", "乌鲁木齐", "克拉玛依", "吐鲁番", "哈密"] },
                    { name: "香港", cities: ["全部", "香港岛", "九龙", "新界"] },
                    { name: "澳门", cities: ["全部", "澳门半岛", "离岛"] },
                    { name: "台湾", cities: ["全部", "台北", "高雄", "基隆", "台中", "台南", "新竹", "嘉义"] }
                ];
            }
        }
    };
</script>

<style scoped>
    body {
        font-size: 100%;
    }
    /* 设置body的字体大小为100% */

    .gongxi2 {
        height: 20px;
    }
    /* 空div的高度 */

    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }
    /* container的左右填充 */

    .phome-container-box {
        margin-left: auto !important;
        margin-right: auto !important;
    }

    .errong2 {
        padding-left: 15px;
        padding-right: 15px;
    }
    /* 另一个container的左右填充 */

    .tn {
        clear: both;
    }
    /* 清除浮动 */

    .province-label {
        flex-shrink: 0;
        margin-right: 10px;
    }
    /* 省份标签样式，保持固定宽度，不收缩，右边距10px */

    .province-links {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-left: 0;
        flex-grow: 1;
        gap: 0.5rem;
    }
    /* 省份链接的容器，使用flex布局，换行排列，间距0.5rem */

    .daxiao {
        font-size: 0.95rem;
    }
    /* 统一设置字体大小 */

    .active {
        color: #18b371 !important;
    }
    /* 选中状态的样式，字体颜色变为#18b371 */

    .card-container {
        display: flex;
        flex-wrap: wrap;
        margin-left: -1px;
        margin-right: -1px;
    }
    /* 卡片容器，使用flex布局，换行排列，左右负边距1px */

    .col-md-4 {
        padding-left: 2px;
        padding-right: 2px;
    }
    /* 卡片列的左右填充 */

    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }

        .errong {
            margin-top: 70px;
        }
        /* 当屏幕宽度大于768px时，固定头部组件，顶部距离0，全宽，z-index为1000，内容区域的顶部外边距70px */
    }

    .G-Field {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 70px;
    }
    /* 分页导航容器，使用flex布局，垂直和水平居中，固定高度70px */

    .page-link {
        color: #6c757d;
    }
    /* 分页链接的默认颜色 */

    .pagination {
        line-height: 1;
        border-color: #dee2e6;
    }
    /* 分页容器的行高和边框颜色 */

    .active > .page-link,
    .page-link.active {
        background-color: #212429 !important;
        color: white !important;
        border-color: #212429 !important;
    }
    /* 选中的分页链接样式，背景颜色和边框颜色为#212429，字体颜色为白色 */

    /* 这个隐藏挂载点不占位 */
    .banner-probe {
        position: absolute;
        left: -99999px;
        top: -99999px;
        width: 1px;
        height: 1px;
        overflow: hidden;
        pointer-events: none;
    }

    /* 真正显示在页面上的红条 */
    .home-diff-banner-wrap {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 5px;
    }

    .home-diff-banner-text {
      display: block;
      width: 100%;
      background: #ffffff;
      color: #ff2b2b;
      padding: 2px 2px;
      border-radius: 0;
      font-size: 1.1rem;
      font-weight: 600;
      line-height: 1.8;
      box-sizing: border-box;
      cursor: pointer;
    }

    #btnpaysucess,
    .modal-body .btn-primary,
    .btn-success {
        background-color: #00c26f !important;
        border: none !important;
    }

    #paymsg {
        color: #00c26f;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #qrcode {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: filter 0.5s ease;
    }

    #countdown {
        font-size: 0.7rem;
        color: red !important;
        text-align: center;
    }

    .pay-option1 {
        margin-right: 40px;
    }
</style>
